'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavigationBarControl = require('../../../lib/ui/NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Sync = function Sync(element) {
  _classCallCheck(this, Sync);

  var fragment = document.createDocumentFragment();
  new _NavigationBarControl2.default(fragment, {
    title: 'Synchroniseren'
  });

  var div = document.createElement('div');
  div.className = 'viewport';

  var p = document.createElement('p');
  p.innerHTML = 'Een ogenblik geduld alstublieft. Uw apparaat synchroniseert uw laatste gegevens, dit kan enkele seconden duren...';

  window.PRIM.bootMessage = document.createElement('p');

  div.appendChild(p);
  div.appendChild(window.PRIM.bootMessage);
  fragment.appendChild(div);

  element.appendChild(fragment);

  window.PRIM.initExternalStorage();
};

exports.default = Sync;


//////////////////
// WEBPACK FOOTER
// ./js/modules/start/action/Sync.js
// module id = 78
// module chunks = 0